import { Map as map } from 'immutable';
const C = require("../constants");

function UpdateTableReducer(state = map(), action) {
    switch (action.type) {
        case C.SALES_TABLE_UPDATE:
            return { data: action.data};
        default:
            return state;
    }
}

export default UpdateTableReducer;


// WEBPACK FOOTER //
// ./src/reducers/UpdateTableReducer.js